import styled from 'styled-components'

import { Filter } from './Filter'
import { useBlogList } from './useBlogList'
import { BlogItem } from '@/components/elements/Blog/BlogItem'
import { Pagination } from '@/components/elements/Pagination'
import { Spacer } from '@/components/elements/Spacer'
import { getYearList } from '@/components/pages/News/dateOptions'

import { useFadeTransition } from '@/hooks/useFadeTransition'
import type { Blog, BlogTag } from '@/types/blog'

type Props = {
  blogList: readonly Blog[]
  tagList: readonly BlogTag[]
}

export const BlogList = ({ blogList, tagList }: Props) => {
  const COUNT_PER_PAGE = 9
  const {
    selectedTags,
    selectedYears,
    displayBlogList,
    currentPage,
    totalCount,
    changeSelectedYear,
    changeSelectedTag,
    transitionPage,
    handleAllYears,
    handleAllTags,
  } = useBlogList(blogList, COUNT_PER_PAGE)
  const { render, transitionFn } = useFadeTransition(300)

  return (
    <div>
      <Filter
        years={getYearList(blogList)}
        tagList={tagList}
        selectedTags={selectedTags}
        selectedYears={selectedYears}
        changeSelectedYear={(year) =>
          transitionFn(() => changeSelectedYear(year))
        }
        changeSelectedTag={(text) =>
          transitionFn(() => changeSelectedTag(text))
        }
        handleAllYears={handleAllYears}
        handleAllTags={handleAllTags}
      />
      <Spacer h={{ sp: 24, pc: 51 }} />
      {render(
        <List>
          {displayBlogList.length > 0 ? (
            displayBlogList.map((item) => <BlogItem {...item} key={item._id} />)
          ) : (
            <Message>一致する記事がみつかりませんでした</Message>
          )}
        </List>
      )}
      {totalCount > 0 && (
        <>
          <Spacer h={{ sp: 70, pc: 100 }} />
          <Pagination
            totalCount={totalCount}
            countPerPage={COUNT_PER_PAGE}
            currentPage={currentPage}
            transitionPage={transitionPage}
          />
        </>
      )}
    </div>
  )
}

const List = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 47px 46px;

  @media screen and (max-width: 1047px) {
    flex-direction: column;
    justify-content: normal;
    row-gap: 24px;
    padding: 0 20px;
  }
`

const Message = styled.h3`
  font-size: 16px;
  letter-spacing: 0.64px;
  line-height: 26px;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0;
  }
`
